import $ from 'jquery'
import Logger from 'Logger'
import { PokerMallApp } from './app.view'
import { setErrorTolocalStorage } from './utils/error'

import './styles/poker-mall.scss'

// 4001
// 4002
// 500004 실버 개월
// 500003 500002 골드 정기
// options { goodsId: 500004, gift: boolean}
export function init(options) {
  $.support.cors = true

  Logger.useDefaults()

  // DEV ENVIRONMENT
  if (NODE_ENV !== 'production' && !$('html').hasClass('ie-legacy')) {
    Logger.info('POKERMALL ENVIRONMENT => ' + NODE_ENV)
    Logger.setLevel(Logger.WARN)
    Logger.setLevel(Logger.INFO)
  } else {
    Logger.setLevel(Logger.OFF)
  }

  try {
    var pokerMall = new PokerMallApp(options)
    return pokerMall
  } catch (error) {
    setErrorTolocalStorage(error)
  }
}
// 결제 브릿지에서 호출되는 함수
export * from './components/pay/pay.result'
